(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["by-header-language"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('.by-header-language[open]').forEach(details=>{if(!details.contains(event.target))details.removeAttribute('open')})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.by-header-language[open]').forEach(details=>{details.removeAttribute('open');details.querySelector('summary').focus()})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["by-model-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('by-model-comparison')) {
  customElements.define('by-model-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = this.querySelector('[data-model-labels]').dataset;
      this.selects = [...this.querySelectorAll('[data-model-select]')];
      this.options = [...this.querySelector('[data-model-options]').content.querySelectorAll('option')].map(o => ({ handle:o.value,title:o.textContent }));
      this.current = { ...this.querySelector('[data-by-model-payload]').dataset };
      this.cache = new Map([[this.current.handle, this.current]]);
      this.status = this.querySelector('[data-model-status]');
      this.output = this.querySelector('[data-model-output]');
      this.onlyDifferences = this.querySelector('[data-differences]');
      this.retry = this.querySelector('[data-model-retry]');
      this.sequence = 0;
      this.fillOptions();
      this.querySelector('[data-model-search]').addEventListener('input', () => this.fillOptions());
      this.selects.forEach(select => select.addEventListener('change', () => { this.fillOptions(); this.compare(); }));
      this.onlyDifferences.addEventListener('change', () => this.filterRows());
      this.retry.addEventListener('click', () => this.compare());
    }
    normalize(value) { return String(value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g,'ss').replace(/[^a-z0-9]/g,''); }
    element(tag, text, className) {
      const el = document.createElement(tag);
      if (text !== undefined) el.textContent = text;
      if (className) el.className = className;
      return el;
    }
    fillOptions() {
      const query = this.normalize(this.querySelector('[data-model-search]').value);
      const selected = this.selects.map(s => s.value);
      const matches = this.options.filter(o => this.normalize(o.title).includes(query));
      this.selects.forEach((select,index) => {
        const fragment = document.createDocumentFragment();
        if (index === 1) fragment.append(new Option(this.labels.choose,''));
        this.options.filter(o => matches.includes(o) || selected.includes(o.handle)).forEach(o => {
          const option = new Option(o.title,o.handle,false,o.handle === selected[index]);
          option.disabled = o.handle === selected[1-index];
          fragment.append(option);
        });
        select.replaceChildren(fragment);
        select.value = selected[index];
      });
      if (query) this.status.textContent = matches.some(o => !selected.includes(o.handle)) ? this.labels.hint : this.labels.noResults;
      else if (!selected[1]) this.status.textContent = this.labels.hint;
    }
    async load(handle,signal) {
      if (this.cache.has(handle)) return this.cache.get(handle);
      const url = new URL(this.current.url,location.origin);
      url.pathname = url.pathname.replace(/[^/]+$/,encodeURIComponent(handle));
      url.search = '';
      url.searchParams.set('section_id',this.dataset.sectionId);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      const response = await fetch(url,{signal,credentials:'same-origin'});
      if (!response.ok) throw new Error('Product unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const payload = doc.querySelector('[data-by-model-payload]');
      if (!payload || payload.dataset.handle !== handle) throw new Error('Product data missing');
      const model = {...payload.dataset};
      this.cache.set(handle,model);
      return model;
    }
    async compare() {
      const sequence = ++this.sequence;
      this.controller?.abort();
      this.controller = new AbortController();
      this.retry.hidden = true;
      this.output.replaceChildren();
      this.output.setAttribute('aria-busy','false');
      this.onlyDifferences.disabled = true;
      const handles = this.selects.map(s => s.value);
      if (!handles[0] || !handles[1] || handles[0] === handles[1]) { this.status.textContent=this.labels.hint; return; }
      this.status.textContent = this.labels.loading;
      this.output.setAttribute('aria-busy','true');
      try {
        const models = await Promise.all(handles.map(h => this.load(h,this.controller.signal)));
        if (sequence !== this.sequence) return;
        this.render(models);
        this.onlyDifferences.disabled = false;
        this.filterRows();
        this.status.textContent = this.labels.ready;
      } catch(error) {
        if (sequence !== this.sequence || error.name === 'AbortError') return;
        this.status.textContent = this.labels.error;
        this.retry.hidden = false;
      } finally { if (sequence === this.sequence) this.output.setAttribute('aria-busy','false'); }
    }
    specs(model) {
      const aliases = [
        ['system',/^(system|maschinentyp|kesselsystem)$/],['pump',/^(pumpe|pumpentyp)$/],
        ['water',/^(wasser|wassertank|wasserversorgung|wasseranschluss)$/],
        ['temperature',/^(temperatursteuerung|temperaturregelung|steuerung|pid)$/],
        ['heat',/^(aufheizzeit|fastheatup)$/],['dimensions',/^(masse|abmessungen)/],
        ['weight',/^gewicht$/],['dosing',/^(dosierung|dosierprinzip)$/],['burrs',/^mahlscheiben$/],
        ['group',/^bruhgruppe$/],['boiler',/^kessel$/],['coffeeBoiler',/^bruhkessel$/],['steamBoiler',/^dampfkessel$/],
        ['adjustment',/^mahlgradeinstellung$/],['hopper',/^bohnenbehalter$/],['preinfusion',/^preinfusion$/],['display',/^display$/]
      ];
      const values = new Map();
      String(model.details || '').split(/\r?\n/).forEach(line => {
        const position=line.indexOf(':');
        if (position<1) return;
        const label=line.slice(0,position).trim(), value=line.slice(position+1).trim();
        if (!value) return;
        const normalized=this.normalize(label);
        const canonical=aliases.find(([,pattern]) => pattern.test(normalized));
        const key=canonical ? canonical[0] : normalized;
        const existing=values.get(key);
        values.set(key,{label:canonical ? this.labels[key] : label,value:existing ? existing.value+'\n'+value : value});
      });
      return values;
    }
    render(models) {
      const table=this.element('table');
      const caption=this.element('caption',this.labels.caption);caption.className='visually-hidden';table.append(caption);
      const head=this.element('thead'),header=this.element('tr');
      header.append(this.element('th',''));
      models.forEach(model => {
        const th=this.element('th');th.scope='col';
        if(model.image) { const img=this.element('img');img.src=model.image;img.alt=model.title;img.width=240;img.height=180;th.append(img); }
        const title=this.element('a',model.title,'by-compare__product-title');title.href=model.url;th.append(title);
        const link=this.element('a',this.labels.view,'by-compare__product-link');link.href=model.url;th.append(link);
        header.append(th);
      });
      head.append(header);table.append(head);
      const body=this.element('tbody');
      const addRow=(label,values,always=false) => {
        const row=this.element('tr');row.dataset.different=String(this.normalize(values[0])!==this.normalize(values[1]));
        if (always) row.dataset.always='true';
        const heading=this.element('th',label);heading.scope='row';row.append(heading);
        values.forEach(value=>row.append(this.element('td',value || this.labels.missing)));
        body.append(row);
      };
      addRow(this.labels.price,models.map(m=>m.price),true);
      addRow(this.labels.vendor,models.map(m=>m.vendor));
      addRow(this.labels.availability,models.map(m=>m.available==='true'?this.labels.available:this.labels.unavailable));
      const bundle=models.some(m=>/bundle|komplettset/i.test(m.productType+' '+m.title));
      if(bundle) addRow(this.labels.allDetails,models.map(m=>m.details));
      else {
        const specs=models.map(m=>this.specs(m));
        const keys=[...new Set([...specs[0].keys(),...specs[1].keys()])];
        if(keys.length) keys.forEach(key=>addRow((specs[0].get(key)||specs[1].get(key)).label,specs.map(s=>s.get(key)?.value)));
        else addRow(this.labels.allDetails,models.map(m=>m.details));
      }
      table.append(body);this.output.append(table);
    }
    filterRows() {
      this.output.querySelectorAll('tbody tr').forEach(row=>{row.hidden=this.onlyDifferences.checked && row.dataset.different==='false' && !row.dataset.always;});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["by-snocks-giveaway"] && !Shopify.designMode) return;
  try {
    (() => {
  const modal = document.getElementById('by-snocks-giveaway');
  if (!modal || typeof modal.showModal !== 'function') return;
  const deadline = Date.parse('2026-10-26T00:00:00+01:00');
  const key = 'by-snocks-giveaway-2026';
  const preview = new URLSearchParams(location.search).get('by_giveaway_preview') === '1';
  let previousOverflow;
  const seen = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
  const close = () => modal.close();
  modal.querySelector('.by-snocks-close').addEventListener('click', close);
  modal.querySelector('.by-snocks-dismiss').addEventListener('click', close);
  modal.querySelector('.by-snocks-cta').addEventListener('click', close);
  modal.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow || ''; remember(); });
  modal.addEventListener('click', event => {
    const rect = modal.getBoundingClientRect();
    if (event.target === modal && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  const open = () => {
    if (Date.now() >= deadline || (!preview && seen())) return;
    if (document.hidden || document.querySelector('dialog[open], [aria-modal="true"]:not([aria-hidden="true"])')) {
      setTimeout(open, 2000); return;
    }
    previousOverflow = document.documentElement.style.overflow;
    modal.showModal();
    document.documentElement.style.overflow = 'hidden';
    remember();
    setTimeout(() => { if (modal.open) close(); }, Math.min(deadline - Date.now(), 2147483647));
  };
  setTimeout(open, preview ? 500 : 9000);
})();
  } catch(e) { console.error(e); }
})();

})();
